import React from "react";
import {Table} from "antd";
import {ColumnsType} from "antd/lib/table";
import {CurrencyLabel} from "../../../Common/components";
import {_t} from "../../../Common/components/InjectIntlContext";
import {usePayouts} from "../../apiHooks";
import {NoData} from "../../../Common/components/NoData";

const columns = (_t: any): ColumnsType<any> => [
  {
    title: _t("Date"),
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: _t("amount"),
    dataIndex: "amount",
    key: "amount",
    render: (val) => <CurrencyLabel value={val}/>,
  },
  {
    title: _t("comment"),
    dataIndex: "comment",
    key: "comment",
  },
];

const useTableData = (id) => {
  const {isLoading, data} = usePayouts({
    user_id: id,
  });
  return {isLoading, data};
};

export function PayoutsWidget({user}) {
  const {data, isLoading} = useTableData(user?.id);
  const translatedColumns = columns(_t);
  return (
    <>
      <Table
        loading={isLoading}
        columns={translatedColumns}
        rowKey="id"
        dataSource={data?.data}
        pagination={false}
        locale={{ emptyText: <NoData /> }}
      />
      <br/>
    </>
  );
}
